import {pick} from "../../utils/utils";
import {Sizes} from "../../core/constants/sizes";
import {ValueOf} from "../../types/interfaces";

export const TagSizes = pick(Sizes, ['_XS', '_S', '_M'])
export type TagSizesType = `${ValueOf<typeof TagSizes>}`

export enum TagType {
	BOLD = 'bold',
	SUBTLE = 'subtle',
}
export type TagTypesType = `${ValueOf<typeof TagType>}`

export const TagClass = {
	root: 'gov-tag',
}
